import React from 'react';

import styled from '@emotion/styled';

import { FlagComponentProps } from '..';

/**
 * Offset between uppercase ascii and regional indicator symbols
 */
 const OFFSET = 127397;

 const StyledEmoji = styled.span<Pick<FlagComponentProps, 'size'>>`
   display: inline-block;
   font-size: ${props => props.size || '1em'};
   line-height: ${props => props.size || '1em'};
   vertical-align: middle;
 `;

export function EmojiFlag({countryIsoCode, size}: FlagComponentProps): JSX.Element {
  const emoji = countryIsoCode
    .toUpperCase()
    .replace(/./g, (char) =>
      String.fromCodePoint(char.charCodeAt(0) + OFFSET)
    );

  return (<StyledEmoji role="img" size={size}>{emoji}</StyledEmoji>);
}
